import { useState, useEffect } from "react";
import { loadShiftMasterBreakType } from "../services/shiftService";

const useBreakTypeList = () => {
    const [breakTypeList, setBreakTypeList] = useState([]);
    const [selectBreakType, setSelectedBreakType] = useState(null);
    const [selectBreakTypeID, setSelectedMaterialID] = useState(null);
    const [isBreakTypeListDataLoaded, setIsBreakTypeListDataLoaded] = useState(false);

    // Fetch department data loadShiftMasterBreakType
    const fetchBreakTypeList = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, p_mode: 0 };

        try {
            const data = await loadShiftMasterBreakType(para);
            if (data && data.length > 0) {
                setBreakTypeList(data);
                setIsBreakTypeListDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isBreakTypeListDataLoaded) {
            fetchBreakTypeList();
        }
    }, [isBreakTypeListDataLoaded]);

    // Function to load department based on selected ID
    const loadBreakTypeListByID = async (selectedID) => {
        await fetchBreakTypeList(selectedID);
    };

    return {
        breakTypeList,
        setBreakTypeList,
        selectBreakType,
        selectBreakTypeID,
        loadBreakTypeListByID,
    };
};

export default useBreakTypeList;
